// extracted by mini-css-extract-plugin
export default {"backToMenuButton":"backToMenuButton_backToMenuButton__lP9OL"};